<div class="content-body">
  <app-breadcrumb [breadcrumb]="breadcrumbList"></app-breadcrumb>
  <div class="container-fluid">
    <div class="card">
      <div class="card-header d-flex justify-content-between align-items-center flex-wrap gap-2">
        <h4 class="card-title mb-0">Daily activity</h4>
        <div class="d-flex gap-2">
          <button *ngIf="canLogActivity" class="btn btn-outline-primary btn-sm" (click)="openModal()"
            [disabled]="loadingService.isLoading()">
            <i class="bi bi-plus-circle me-1"></i> Add activity
          </button>
          <button *ngIf="canReports" class="btn btn-primary btn-sm" (click)="exportCsv()"
            [disabled]="loadingService.isLoading()">
            <i class="fa fa-download me-1"></i> Export CSV
          </button>
        </div>
      </div>
      <div class="card-body">
        <form [formGroup]="filterForm">
          <div class="row g-2 mb-3 align-items-end">
            <div class="col-md-3" *ngIf="canReports">
              <label class="form-label">Person</label>
              <ng-select [items]="people.items" bindValue="value" bindLabel="label" placeholder="Select person"
                class="select2 select2-sm" formControlName="user_id" [typeahead]="people.search$" [virtualScroll]="true"
                (scrollToEnd)="people.scrollEnd()" (change)="load()" [clearable]="false"></ng-select>
            </div>
            <div class="col-md-2">
              <label class="form-label">From</label>
              <input type="date" class="form-control input-default search-textbox-height" formControlName="from" (change)="load()" />
            </div>
            <div class="col-md-2">
              <label class="form-label">To</label>
              <input type="date" class="form-control input-default search-textbox-height" formControlName="to"
                [min]="filterForm.value.from" (change)="load()" />
            </div>
          </div>
        </form>

        <div class="table-responsive">
          <table class="table table-hover align-middle">
            <thead>
              <tr>
                <th>Date</th><th>From</th><th>To</th><th>Location</th><th>Linked to</th>
                <th>Client type</th><th>Type</th><th>Remarks</th><th>Source</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="loadingService.isLoading()">
                <td colspan="9" class="text-center py-4">
                  <div class="spinner-border text-primary" role="status"><span class="visually-hidden">Loading...</span></div>
                </td>
              </tr>
              <tr *ngIf="!loadingService.isLoading() && logs.length === 0">
                <td colspan="9" class="text-center py-4">No activity in this period</td>
              </tr>
              <tr *ngFor="let log of logs">
                <td class="text-nowrap">{{ log.started_at | date: 'd MMM' }}</td>
                <td class="mono">{{ log.started_at | date: 'HH:mm' }}</td>
                <td class="mono">{{ log.ended_at ? (log.ended_at | date: 'HH:mm') : '—' }}</td>
                <td>{{ log.location_text || '—' }}</td>
                <td>
                  <a *ngIf="log.property" [routerLink]="['/admin/properties/property-view', log.property.id, 1]">{{ log.property.name }}</a>
                  <span *ngIf="!log.property">{{ linkedTo(log) || '—' }}</span>
                </td>
                <td>{{ log.client_type || '—' }}</td>
                <td>{{ log.activity_type }}</td>
                <td>{{ log.remarks || '—' }}</td>
                <td>
                  <a *ngIf="log.task" class="source-task" [routerLink]="['/admin/tasks/view', log.task.id]">Task {{ log.task.task_id }}</a>
                  <span *ngIf="!log.task" class="text-muted">Logged manually</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">
          <div class="totals" *ngIf="totals">
            Totals: {{ totals.entries }} entries · {{ totals.site_visits }} site visits · {{ hoursLabel }} logged.
            Rows marked "Task" came from check-in / check-out; others were logged manually.
          </div>
          <app-pagination [page]="page" [totalPage]="totalPage" (newPage)="pageChange($event)"></app-pagination>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Add activity offcanvas -->
<div #activityModal class="offcanvas offcanvas-end customeoff {{ showModal ? 'show' : '' }}" tabindex="-1" data-bs-backdrop="static">
  <div class="offcanvas-header">
    <h5 class="modal-title">Add activity</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"><i class="fa-solid fa-xmark"></i></button>
  </div>
  <div class="offcanvas-body">
    <div class="container-fluid">
      <form [formGroup]="activityForm" (ngSubmit)="submitActivity(true)" autocomplete="off">
        <div class="row">
          <div class="col-12 mb-3">
            <label class="form-label d-block">Linked to</label>
            <div class="btn-group btn-group-sm link-switch mb-2" role="group">
              <input type="radio" class="btn-check" name="act-link" id="act-link-none" [checked]="linkType === 'none'" (change)="setLinkType('none')" />
              <label class="btn btn-outline-primary" for="act-link-none">None</label>
              <input type="radio" class="btn-check" name="act-link" id="act-link-property" [checked]="linkType === 'property'" (change)="setLinkType('property')" />
              <label class="btn btn-outline-primary" for="act-link-property">Property</label>
              <input type="radio" class="btn-check" name="act-link" id="act-link-lead" [checked]="linkType === 'lead'" (change)="setLinkType('lead')" />
              <label class="btn btn-outline-primary" for="act-link-lead">Lead</label>
            </div>
            <ng-select *ngIf="linkType === 'property'" [items]="properties.items" bindValue="value" bindLabel="label"
              placeholder="Search property" class="select2" formControlName="property_id" [typeahead]="properties.search$"
              [virtualScroll]="true" (scrollToEnd)="properties.scrollEnd()"></ng-select>
            <ng-select *ngIf="linkType === 'lead'" [items]="leads.items" bindValue="value" bindLabel="label"
              placeholder="Search lead" class="select2" formControlName="related_id" [typeahead]="leads.search$"
              [virtualScroll]="true" (scrollToEnd)="leads.scrollEnd()"></ng-select>
          </div>
          <div class="col-12 mb-3">
            <label class="form-label">Type <span class="text-danger">*</span></label>
            <ng-select [items]="activityTypes" bindValue="value" bindLabel="label" placeholder="Select type" class="select2"
              formControlName="activity_type" [clearable]="false"></ng-select>
            <div class="text-danger small" *ngIf="isFieldInvalid('activity_type')">Type is required</div>
          </div>
          <div class="col-md-4 mb-3">
            <label class="form-label">Date <span class="text-danger">*</span></label>
            <input type="date" class="form-control" formControlName="date" [class.is-invalid]="isFieldInvalid('date')" />
          </div>
          <div class="col-md-4 mb-3">
            <label class="form-label">From <span class="text-danger">*</span></label>
            <input type="time" class="form-control" formControlName="from_time" [class.is-invalid]="isFieldInvalid('from_time')" />
          </div>
          <div class="col-md-4 mb-3">
            <label class="form-label">To</label>
            <input type="time" class="form-control" formControlName="to_time" />
          </div>
          <div class="col-12 mb-3">
            <label class="form-label">Location</label>
            <input type="text" class="form-control" formControlName="location_text" placeholder="Where were you?" />
          </div>
          <div class="col-12 mb-3">
            <label class="form-label">Remarks</label>
            <textarea class="form-control" rows="3" formControlName="remarks" placeholder="What did you do?"></textarea>
          </div>
        </div>
        <div class="d-flex flex-wrap align-items-center gap-2">
          <button class="btn btn-primary" type="submit" [disabled]="activityForm.invalid || loadingService.isLoading()">Save &amp; add another</button>
          <button class="btn btn-outline-primary" type="button" (click)="submitActivity(false)" [disabled]="activityForm.invalid || loadingService.isLoading()">Save &amp; finish</button>
          <button class="btn btn-danger light" type="button" (click)="closeModal()">{{ savedCount > 0 ? 'Done' : 'Cancel' }}</button>
          <span class="text-muted small ms-auto" *ngIf="savedCount > 0">{{ savedCount }} saved for {{ activityForm.value.date }}</span>
        </div>
      </form>
    </div>
  </div>
</div>
@if (showModal) {
<div class="offcanvas-backdrop fade show" (click)="closeModal()"></div>
}
